/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface CalendarEventLocation
 */
export interface CalendarEventLocation {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CalendarEventLocation
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventLocation
     */
    locationName: string | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CalendarEventLocation
     */
    classRoomId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof CalendarEventLocation
     */
    classRoomName: string | null;
}

/**
 * Check if a given object implements the CalendarEventLocation interface.
 */
export function instanceOfCalendarEventLocation(value: object): value is CalendarEventLocation {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('locationName' in value) || value['locationName'] === undefined) return false;
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    if (!('classRoomName' in value) || value['classRoomName'] === undefined) return false;
    return true;
}

export function CalendarEventLocationFromJSON(json: any): CalendarEventLocation {
    return CalendarEventLocationFromJSONTyped(json, false);
}

export function CalendarEventLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarEventLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'locationName': json['locationName'],
        'classRoomId': ActorActivityRecordActorUserIdFromJSON(json['classRoomId']),
        'classRoomName': json['classRoomName'],
    };
}

export function CalendarEventLocationToJSON(json: any): CalendarEventLocation {
    return CalendarEventLocationToJSONTyped(json, false);
}

export function CalendarEventLocationToJSONTyped(value?: CalendarEventLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'locationName': value['locationName'],
        'classRoomId': ActorActivityRecordActorUserIdToJSON(value['classRoomId']),
        'classRoomName': value['classRoomName'],
    };
}

